<template>
    <v-app ref="app" style="height: 100%">
        <!-- Navigation Drawer -->
        <v-navigation-drawer permanent :rail="minimize" mobile-breakpoint="md" color="#182230" class="app-sidebar">
            <v-list class="white-text">
                <v-list-item v-show="!minimize">
                    <v-list-item-title class="app-brand text-center">UCAD Diplôme</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="minimize" class="px-2">
                    <v-avatar class="mx-auto d-flex">
                        <v-img src="/img/logoucad2.png"></v-img>
                    </v-avatar>
                </v-list-item>
                <v-list-item v-else class="px-2 w-100">
                    <v-img src="/img/logo-ucad-blue.png"></v-img>
                </v-list-item>

                <v-list-item v-show="!minimize" link class="app-user-card">
                    <v-list-item-title class="text-subtitle-1 font-weight-bold">
                        {{ user.prenom }} {{ user.nom }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="app-user-email">{{ user.email }}</v-list-item-subtitle>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list nav density="compact" class="app-menu white-text">
                <v-list-item
                    v-for="menu in menuComputed"
                    :key="menu.text"
                    link
                    :to="{ name: menu.page }"
                    class="app-menu-item"
                >
                    <template v-slot:prepend>
                        <v-icon color="white">{{ menu.icon }}</v-icon>
                    </template>
                    <v-list-item-title>{{ menu.text }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <!-- App Bar -->
        <v-app-bar flat height="56" :color="isDark ? '#111827' : '#ffffff'" class="app-topbar">
            <v-app-bar-nav-icon class="app-icon-button" @click="toggleSidebar"></v-app-bar-nav-icon>

            <v-toolbar-title class="app-title">
                <span v-show="minimize">DIPLOME UCAD&nbsp;&nbsp;─&nbsp;&nbsp;</span>
                {{ 'Université Cheikh Anta Diop de Dakar' }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <theme-switcher></theme-switcher>

            <div class="mx-6"></div>

            <user-dropdown-vue></user-dropdown-vue>
        </v-app-bar>

        <!-- Content -->
        <v-main class="app-main">
            <v-card
                flat
                height="100%"
                :color="isDark ? '#151f2e' : '#f4f7fb'"
                class="app-content"
                rounded="0"
            >
                <breadcrumbs></breadcrumbs>
                <router-view :etab_id="user.etablissement_id"></router-view>
            </v-card>
        </v-main>
    </v-app>
</template>

<script lang="js">
import ThemeSwitcher from '../components/shared/ThemeSwitcher.vue';
import UserDropdownVue from '../components/shared/UserDropdown.vue';
import Breadcrumbs from '../components/shared/Breadcrumbs.vue';

const PROFILE_SUPERADMIN = 'SUPERADMIN';
const PROFILE_ADMIN = 'ADMIN';
const PROFILE_ADMIN_ETABLISSEMENT = 'ADMIN_ETABLISSEMENT';
const PROFILE_CSA = 'CSA';
const PROFILE_DAP = 'DAP';
const PROFILE_DAJ = 'DAJ';
const PROFILE_EDITION = 'EDITION';

export default {
    name: 'AdminLayout',
    components: { ThemeSwitcher, UserDropdownVue, Breadcrumbs },
    data: () => ({
        minimize: false,
        menuItems: [
            {
                text: 'Demande Alumni',
                icon: 'mdi-application-import',
                page: 'DemandeAlumniIndex',
                roles: [
                    PROFILE_SUPERADMIN,
                    PROFILE_ADMIN,
                    PROFILE_ADMIN_ETABLISSEMENT,
                    PROFILE_CSA,
                    PROFILE_DAP,
                    PROFILE_EDITION,
                    PROFILE_DAJ
                ]
            },
            {
                text: 'Utilisateur',
                icon: 'mdi-account-group',
                page: 'UserIndex',
                roles: [PROFILE_SUPERADMIN]
            }
        ]
    }),

    computed: {
        user() {
            return this.$store.getters['auth/user'] ?? {};
        },
        menuComputed() {
            return this.menuItems.filter((x) => x.roles.includes(this.user.role));
        },
        isDark() {
            return this.$vuetify.theme.global.current.dark;
        }
    },
    methods: {
        toggleSidebar() {
            this.minimize = !this.minimize;
        }
    },
    watch: {
        isDark(val) {
            document.body.style.backgroundColor = val ? '#1a202e' : '';
        }
    }
};
</script>
<style>
.theme--dark.v-data-table {
    background-color: #070e1f !important;
}
.white-text * {
    color: whitesmoke !important;
}
.app-sidebar {
    border-right: 0 !important;
}
.app-brand {
    color: #f8fafc;
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: 0;
}
.app-user-card {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    margin: 8px 12px 12px;
}
.app-user-email {
    color: #cbd5e1 !important;
}
.app-menu {
    padding: 10px 8px;
}
.app-menu-item {
    border-radius: 8px;
    margin-bottom: 4px;
}
.app-menu-item.v-list-item--active {
    background: rgba(255, 255, 255, 0.12);
}
.app-topbar {
    border-bottom: 1px solid #e5e7eb !important;
}
.v-theme--dark .app-topbar {
    border-bottom-color: #253244 !important;
}
.app-icon-button {
    border-radius: 8px;
}
.app-title {
    color: #0f172a;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 0;
}
.v-theme--dark .app-title {
    color: #f8fafc;
}
.app-main {
    background: #f4f7fb;
}
.v-theme--dark .app-main {
    background: #151f2e;
}
.app-content {
    padding: 12px 16px;
}
</style>
